import types from 'actions/types'
import Immutable from 'seamless-immutable'
import {get} from 'lodash'
import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'

const timeKey = (state = Immutable('custom:'), action) => {
    switch (action.type) {
        case types.PURCHASING_PURCHASE_ORDER_FINDER_UPDATE_FILTERS:
            return get(action, 'filters.timeKey', state)
        default:
            return state
    }
}

const selectedOrderId = (state = null, action) => {
    switch (action.type) {
        case types.PURCHASING_PURCHASE_ORDER_FINDER_LOAD_ITEMS:
            return action.orderId
        case types.PURCHASING_PURCHASE_ORDER_FINDER_SELECT_ORDER:
            return action.orderId
        default:
            return state
    }
}

export const statusTypes = (state = [], action) => {
    switch (action.type) {
        case types.PURCHASING_PURCHASE_ORDER_FINDER_UPDATE_FILTERS:
            return get(action, 'filters.statusTypes', state)
        default:
            return state
    }
}

export const companies = (state = [], action) => {
    switch (action.type) {
        case types.PURCHASING_PURCHASE_ORDER_FINDER_UPDATE_FILTERS:
            return get(action, 'filters.companies', state)
        default:
            return state
    }
}

export const contacts = (state = [], action) => {
    switch (action.type) {
        case types.PURCHASING_PURCHASE_ORDER_FINDER_UPDATE_FILTERS:
            return get(action, 'filters.contacts', state)
        default:
            return state
    }
}

export const dateTypes = (state = [], action) => {
    switch (action.type) {
        case types.PURCHASING_PURCHASE_ORDER_FINDER_UPDATE_FILTERS:
            return get(action, 'filters.dateTypes', state)
        default:
            return state
    }
}

export const targetStart = (state = null, action) => {
    switch (action.type) {
        case types.PURCHASING_PURCHASE_ORDER_FINDER_UPDATE_FILTERS:
            return get(action, 'filters.targetStart', state)
        default:
            return state
    }
}

export const targetEnd = (state = null, action) => {
    switch (action.type) {
        case types.PURCHASING_PURCHASE_ORDER_FINDER_UPDATE_FILTERS:
            return get(action, 'filters.targetEnd', state)
        default:
            return state
    }
}

export const purchasingContextSelectorOrdersPivotTableKey = 'purchasingContext.selector.orders'
export const purchasingContextSelectorOrderItemsPivotTableKey = 'purchasingContext.selector.items'

export default combineReducers({
    orders: createPivotTableReducer({
        key: purchasingContextSelectorOrdersPivotTableKey,
        defaultSortColumn: 'createdDate',
        defaultSortDirection: 'desc',
        pageSize: 50,
        defaultGridStretch: false,
        defaultAreAllRowsSelected: false,
        defaultCanSelectRows: false,
        retainEdits: false,
        onNewEntity: e => e,
        canSearch: true,
    }),
    items: createPivotTableReducer({
        key: purchasingContextSelectorOrderItemsPivotTableKey,
        defaultSortColumn: Immutable('itemId'),
        defaultSortDirection: Immutable('asc'),
        pageSize: 100,
    }),
    timeKey,
    selectedOrderId,
    statusTypes,
    companies,
    contacts,
    dateTypes,
    targetStart,
    targetEnd,
})
